import React, { useState, createRef, useEffect } from "react";
import Auth_brand from "./Auth_brand";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";
import { useNetworkState } from "react-use";
const Register = () => {
  let navigate = useNavigate();
  const isOnline = useNetworkState();
  let location = useLocation();
  console.log("isONline  === ", isOnline);
  let userDetail = localStorage.getItem("ship_rocket_user");

  // console.log("userDetail ===>   ",userDetail);
  const [state, setState] = useState({ email: "", password: "" });
  const [regsterState, setRegsterState] = useState({
    email: "",
    password: "",
    full_name: "",
    company_name: "",
    mobile_number: "",
    referral_code: "",
    state: "",
    city: "",
  });
  const [userState, setUserState] = useState({ full_name: "" });
  const [trackState, setTrackState] = useState({ tracking_no: "" });
  const [countrylist, setcountrylist] = React.useState([]);
  const [statelist, setstatelist] = React.useState([]);
  const [citylist, setcitylist] = React.useState([]);
  React.useEffect(() => {
    stateList();
  }, []);

  const stateList = () => {
    let full_api = config.apiUrl + `/country/state_list`;
    let sendData = { t_country_id: 244 };
    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setstatelist(res.data.output);
      })
      .catch((e) => {
        // setIsLoading(false)
      });
  };

  const handleSelectState = (e) => {
    setRegsterState({ ...regsterState, state: e.target.value });
    // let full_api = config.apiUrl + `/country/all_city_list`;
    // let sendData= { state_id:e.target.value};
    // axios.post(full_api, sendData, { headers: config.headers }).then((res) => {
    //     setcitylist(res.data.output)
    //  }).catch((e) => {
    //  });
  };

  const handleSelectCity = (e) => {
    setRegsterState({ ...regsterState, city: e.target.value });
  };

  useEffect(() => {
    if (userDetail != null) {
      let uDetail = JSON.parse(userDetail);
      setUserState({ full_name: uDetail.full_name });
      config.UserId = uDetail.customer_id;
    }
  }, []);
  useEffect(() => {
    // Autofill from query params
    const params = new URLSearchParams(location.search);
    const name = params.get("name");
    const email = params.get("email");
    const whatsapp = params.get("whatsapp");

    setRegsterState((prev) => ({
      ...prev,
      full_name: name || prev.full_name,
      email: email || prev.email,
      mobile_number: whatsapp || prev.mobile_number,
    }));
  }, [location.search]);

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
  });

  const inputHandleChangeR = (e) => {
    const value = e.target.value;
    const text = e.target.name;
    setRegsterState({ ...regsterState, [text]: value });
  };

  const regitserButton = () => {
    console.log("regsterState", regsterState);
    if (
      regsterState.email != "" &&
      regsterState.password != "" &&
      regsterState.full_name != "" &&
      regsterState.company_name != ""
    ) {
      let full_api = config.apiUrl + `/user/register_api`;
      let sendData = regsterState;
      // console.log("bb", sendData);
      axios
        .post(full_api, sendData, { headers: config.headers })
        .then((res) => {
          // console.log("res ", res);
          if (res.data.isValid) {
            localStorage.setItem(
              "ship_rocket_user",
              JSON.stringify(res.data.output)
            );
            localStorage.setItem("kyc_checked", "false");
            localStorage.removeItem("hasSeenCarousel");
            setUserState({ full_name: res.data.output.full_name });
            config.UserId = res.data.output.customer_id;
            Toast.fire({
              background: "#3659cd",
              type: "success",
              title: res.data.message,
              color: "white",
            });
            setTimeout(() => {
              window.location.replace("/index");
            }, 1000);
          } else {
            Toast.fire({
              background: "#206bc4",
              type: "unsuccess",
              title: res.data.message,
              color: "white",
            });
          }
        })
        .catch((e) => {});
    } else {
      Toast.fire({
        background: "#a61c09",
        type: "unsuccess",
        title: "Please fill all fields",
        color: "white",
      });
    }
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/assets/js/elite.js?v=27";
    script.async = false;

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);
  return (
    <div>
      <section class="auth-page">
        <div class="auth-form-panel">
          <div class="auth-form-wrap">
            <header>
              <a href="/login" class="auth-logo" aria-label="SkyShip home">
                <span class="auth-logo-mark">S</span>
                <span class="auth-logo-name">SkyShip</span>
              </a>

              <div class="auth-heading">
                <h1 class="auth-title">Create your account</h1>
                <p class="auth-subtitle">
                  Register to access the customer panel and start tracking your
                  shipments.
                </p>
              </div>
            </header>

            <form
              class="auth-form"
              onSubmit={(e) => {
                e.preventDefault();
                regitserButton();
              }}
            >
              <div class="row g-2 auth-form">
                <div class="col-12 col-sm-6">
                  <div class="auth-field">
                    <label class="form-label" for="fullname">
                      Full name
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="fullname"
                      name="full_name"
                      onChange={(e) => inputHandleChangeR(e)}
                      value={regsterState.full_name}
                      placeholder="Your full name"
                      autocomplete="name"
                      autofocus
                      required
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="auth-field">
                    <label class="form-label" for="company">
                      Company name
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="company"
                      name="company_name"
                      onChange={(e) => inputHandleChangeR(e)}
                      placeholder="Your company"
                      autocomplete="organization"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="row g-2">
                <div class="col-12 col-sm-6">
                  <div class="auth-field">
                    <label class="form-label" for="email">
                      Email address
                    </label>
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      name="email"
                      onChange={(e) => inputHandleChangeR(e)}
                      value={regsterState.email}
                      placeholder="you@company.com"
                      autocomplete="email"
                      required
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="auth-field">
                    <label class="form-label" for="mobile">
                      Mobile number
                    </label>
                    <input
                      type="tel"
                      class="form-control"
                      id="mobile"
                      name="mobile_number"
                      onChange={(e) => inputHandleChangeR(e)}
                      value={regsterState.mobile_number}
                      placeholder="+91 00000 00000"
                      autocomplete="tel"
                      pattern="[0-9+ ]{10,16}"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="auth-field">
                <label class="form-label" for="password">
                  Create password
                </label>
                <div class="auth-password">
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    name="password"
                    onChange={(e) => inputHandleChangeR(e)}
                    placeholder="Enter new password"
                    autocomplete="new-password"
                    minlength="8"
                    required
                  />
                  <button
                    type="button"
                    class="auth-eye"
                    data-target="password"
                    aria-label="Show password"
                    aria-pressed="false"
                  >
                    <i class="bi bi-eye"></i>
                  </button>
                </div>
              </div>

              <div class="auth-options">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="acceptTerms"
                    checked
                    required
                  />
                  <label class="form-check-label" for="acceptTerms">
                    I accept the{" "}
                    <a href="terms" target="_blank">
                      terms &amp; conditions
                    </a>
                  </label>
                </div>
              </div>

              <button type="submit" class="btn btn-primary auth-submit">
                <span class="auth-spinner" aria-hidden="true"></span>
                <span class="auth-submit-label">Register Account</span>
                <i class="bi bi-arrow-right"></i>
              </button>
            </form>

            <p class="auth-signup">
              Already have an account? <a href="/login">Sign in</a>
            </p>
          </div>
        </div>

        <Auth_brand />
      </section>
    </div>
  );
};

export default Register;
